import { REPLICATION_SIZE } from '../../../utils/constants';
import {
  auditFields,
  buildReplication,
  getMutationArrayNestedValue,
  getMutationBooleanValue,
  getMutationIsActive,
  getMutationNestedValue,
  getMutationStringValue
} from '../utils';

/**
 * Pull builder for cross matching data
 *
 * @param {*} db RxDB database
 */
const pullBuilder = (doc) => {
  const where = doc ? `lastmodifiedAt_Gt: "${doc.lastmodifiedAt}"` : '';

  const query = `{
    listCrossMatchings(
      limit: ${REPLICATION_SIZE}
      offset: 0
      ordering: "lastmodifiedAt,ASC"
      ${where}
    ) {
      results {
        id
        icode

        isMatch
        status
        details

        bloodBank { id name address stockUnit { id name address } }
        bloodProduct {
          id icode volume bloodType expiryDate
          bloodProductType { id name shelfLife shelfLifeUnit }
        }
        transfusion {
          id
          icode
          dueTime
          status
          bloodProductType { id name shelfLife shelfLifeUnit }
          bloodProduct {
            id icode volume bloodType expiryDate
            bloodProductType { id name shelfLife shelfLifeUnit }
          }
          hospital {
            id name address
            bloodBank { id name address stockUnit { id name address } }
          }
          patient { id patientCode fullName personName gender bloodType }
        }

        consumables { id name }
        equipments { id name }
        healthCareWorkers { username name }

        ${auditFields}
      }
    }
  }`;

  return { query, variables: {} };
};

/**
 * Push builder for cross matching data
 *
 * @param {*} db RxDB database
 */
const pushBuilder = (doc) => {
  const query = `
    mutation {
      upsertCrossMatching(
        input: {
          ${getMutationStringValue(doc, 'id')}
          ${getMutationBooleanValue(doc, 'isMatch')}
          ${getMutationStringValue(doc, 'status')}
          ${getMutationStringValue(doc, 'details')}

          ${getMutationNestedValue(doc, 'bloodBank')}
          ${getMutationNestedValue(doc, 'bloodProduct')}
          ${getMutationNestedValue(doc, 'transfusion')}

          ${getMutationArrayNestedValue(doc, 'consumableIds', 'consumables')}
          ${getMutationArrayNestedValue(doc, 'equipmentIds', 'equipments')}
          ${getMutationArrayNestedValue(doc, 'healthCareWorkerNames', 'healthCareWorkers', 'username')}

          ${getMutationIsActive(doc)}
        }
      ) {
        id
      }
    }
  `;

  return { query, variables: {} };
};

/**
 * Synchronize cross matching data with GraphQL endpoint
 */
export const syncCrossMatching = (...args) => {
  return buildReplication(
    ...args,
    'crossMatching',
    { pullBuilder, pullQuery: 'listCrossMatchings' },
    { pushBuilder }
  );
};
